module.exports = __webpack_public_path__ + "img/JoiningApplicationSubscriptions.a26af9ba.svg";